// Translation: Utility > Feedback (Arabic)
export default Object.freeze({
	hint: ''
})
